import { render, staticRenderFns } from "./ModalLayout.vue?vue&type=template&id=0508946b&scoped=true&"
import script from "./ModalLayout.vue?vue&type=script&lang=js&"
export * from "./ModalLayout.vue?vue&type=script&lang=js&"
import style0 from "./ModalLayout.vue?vue&type=style&index=0&id=0508946b&scoped=true&lang=less&"
import style1 from "./ModalLayout.vue?vue&type=style&index=1&id=0508946b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0508946b",
  null
  
)

export default component.exports